import React from 'react';
import styles from './SidePane.module.scss';
import { ReactComponent as Colapse } from 'assets/colapse.svg';
import cx from "classnames";
import Text from 'components/Text/Text';
import { ReactComponent as Logo } from 'assets/dfh.svg';
import { ReactComponent as EisengardLogo } from 'assets/eisengard_logo.svg';
import { store } from 'stores/Store';

interface ISidePage {
  children: any;
  sidepaneContent: React.ReactNode;
  isOpen: boolean;
  togglePane: () => void;
  header?: string;
}
const SidePane: React.FC<ISidePage> = ({
  children, 
  isOpen, 
  sidepaneContent,
  togglePane,
  header = ''
}) => {

  let touchStartX: number = 0;
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    const touchEndX = e.changedTouches[0].clientX;
    const swipeDistance = touchEndX - touchStartX;    
    if (swipeDistance > 100) { 
      // openPane();
    }
    if (swipeDistance < -100) { 
      // closePane();
    }
  };

  const handleMainContentClick = () => {
    if (isOpen) {
      togglePane();
    }
  };

  return (
    <div className={styles.contentWrapper} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
      {isOpen && store.impersonatedUser && (
        <div className={styles.sidepaneWrapper}>
          <div className={cx(styles.header)} >
            <div onClick={togglePane} className={styles.centered} style={{marginRight: '20px', cursor: 'pointer'}}>
              <Colapse width={28} height={28}/>
            </div>
            {/*<Logo width={48} height={48} style={{marginRight: '15px'}}/>*/}
            <Text textAlign='left' color='#E64B37' bold>{header}</Text>                        
          </div>                    
          <div className={styles.sidepaneContent}>            
            {sidepaneContent}            
          </div>                    
          <div className={styles.footer}>            
            <EisengardLogo width={34} height={34} style={{paddingRight: '10px'}} />
            <Text width='auto' type="small" textAlign="left">by Eisengard AI</Text>            
          </div>
          {/*store.refreshDataTime && <p className={styles.timeRefresh}>Data last refreshed as of {store.refreshDataTime}</p> */}
          {store.refreshDataTime && <p style={{textAlign: 'center', fontSize: '16px', color: '#fff', backgroundColor: '#E95540', padding: '5px'}}>Data last refreshed as of {store.refreshDataTime}</p>}
          {/*<p style={{textAlign: 'center', fontSize: '16px', color: '#fff', backgroundColor: '#E95540', padding: '5px'}}>Data last refreshed as of 4.25.25</p>*/}
        </div>
      )}
      <div 
        className={cx(styles.childrenWrapper, {[styles.childrenWrapper_fw]: !isOpen})}
        onClick={handleMainContentClick}
      >
        {children}
      </div>
    </div>
  );
};

export default SidePane;
